import { AttributeType, PanelSection } from '@store/Quote/Quote.types';

export enum PanelTitles {
  MailingAddress = 'Mailing Address',
  Location = 'Location',
  Jurisdiction = 'Jurisdiction',
  Policy = 'Policy',
  RatingModifiers = 'Rating Modifiers',
  LiabilityRisk = 'Liability Risk',
  PropertyRisk = 'Property Risk',
  Forms = 'Forms',
}

export type Attribute = AttributeType['attribute'];

export type PanelSectionWithFields = PanelSection & {
  shownFields: AttributeType[];
  fieldGroups?: PanelSectionWithFields[];
};

export enum QuoteItemTypeCodeNames {
  Jurisdiction = 'Jurisdiction',
  Policy = 'Policy',
}
